/*
  Which subjects of today's Remember task are finished.

  The subject page calls markRememberDone(examType, subject) once the user has
  finished that subject's questions for the day. The picker reads it back and
  colours the stop as finished. Progress is kept per exam type and per IST day,
  so every morning the road starts fresh.
*/
const PREFIX = 'cf_remember_done';

const istDay = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata' }).format(new Date());
const accountId = () => {
  try {
    const user = JSON.parse(localStorage.getItem('vidyacards_user') || 'null');
    return user?._id || user?.id || 'anonymous';
  } catch {
    return 'anonymous';
  }
};
const keyFor = examType => `${PREFIX}:${accountId()}:${examType}:${istDay()}`;
const legacyKeyFor = examType => `${PREFIX}:${examType}:${istDay()}`;

export function getRememberDone(examType) {
  try {
    const key = keyFor(examType);
    let saved = localStorage.getItem(key);
    if (saved === null && accountId() !== 'anonymous') {
      saved = localStorage.getItem(legacyKeyFor(examType));
      if (saved !== null) {
        localStorage.setItem(key, saved);
        localStorage.removeItem(legacyKeyFor(examType));
      }
    }
    return new Set(JSON.parse(saved || '[]'));
  } catch {
    return new Set();
  }
}

export function markRememberDone(examType, subject) {
  try {
    const done = getRememberDone(examType);
    done.add(subject);
    localStorage.setItem(keyFor(examType), JSON.stringify([...done]));

    // forget earlier days
    const today = `:${istDay()}`;
    Object.keys(localStorage).forEach(k => {
      if (k.startsWith(`${PREFIX}:`) && !k.endsWith(today)) localStorage.removeItem(k);
    });
    window.dispatchEvent(new Event('cf-remember-progress'));
  } catch { /* storage unavailable */ }
}

export function replaceRememberDone(examType, subjects) {
  try {
    localStorage.setItem(keyFor(examType), JSON.stringify(subjects));
    window.dispatchEvent(new Event('cf-remember-progress'));
  } catch { /* storage unavailable */ }
}

export function clearRememberDone(examType, subject) {
  try {
    const done = getRememberDone(examType);
    done.delete(subject);
    localStorage.setItem(keyFor(examType), JSON.stringify([...done]));
    window.dispatchEvent(new Event('cf-remember-progress'));
  } catch { /* storage unavailable */ }
}